/* src/app/forms/wizard-configuracao/main-configuracao-view/main-configuracao-view.component.scss */
.gradient {
  background-color: gainsboro;
  height: 30%;
  width: 100%;
  border-radius: 4px;
}
.example-container {
  width: 400px;
  height: 200px;
  margin: 12px;
  border: 1px solid #555;
}
:host {
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 10px;
  padding: 5px;
}
mat-drawer-content {
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.container {
  position: absolute;
  height: 100%;
  left: 0;
  right: 0;
}
.sidenav {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  background: rgba(255, 0, 0, 0.5);
}
.second-view {
  display: flex;
  flex-direction: column;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  height: 100%;
  overflow: hidden;
}
.headerTitle {
  font-size: 19px;
}
.headerDesc {
  font-size: 19px;
}
/*# sourceMappingURL=main-configuracao-view.component.css.map */
